import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRegBookmark, FaBookmark } from 'react-icons/fa';
import { useBookmarkContext } from '../../Contexts/BookmarkProvider';
import { LoginContext } from '../../Contexts/LoginContext';
import { showToast } from '../utils/ShowToast';
import Loader from '../../Components/utils/Loader';
import { formatCityRegion } from '../utils/formatAddress';

const VendorCard = ({ vendor }) => {
  const navigate = useNavigate();
  const { addBookmark, removeBookmark, isBookmarked, actionLoading, loading } = useBookmarkContext();
  const { isLogin } = useContext(LoginContext);
  const sellerId = vendor._id || vendor.id;

  const handleCardClick = () => {
    navigate(`/vendorDetail/${sellerId}`);
  };

  const handleBookmarkToggle = (e) => {
    e.stopPropagation();
    if (!isLogin) {
      showToast('Please login to bookmark sellers', 'warning');
      return;
    }
    if (isBookmarked(sellerId)) {
      removeBookmark(sellerId);
    } else {
      addBookmark(vendor);
    }
  };

  return (
    <div className="vendorCard" onClick={handleCardClick}>
      <div className="vendorImageContainer">
        <img
          src={vendor.profileImage || vendor.imageSrc}
          alt={vendor.displayName || vendor.name}
          className="vendorImage"
        />
        {isLogin && (
          <div className="bookmarkIcon" onClick={handleBookmarkToggle}>
            {actionLoading[sellerId] || loading ? (
              <Loader type="miniPlus" />
            ) : isBookmarked(sellerId) ? (
              <FaBookmark />
            ) : (
              <FaRegBookmark />
            )}
          </div>
        )}
      </div>
      <div className="vendorContent">
        <div className="titleRating">
          <h3>{vendor.displayName || vendor.name}</h3>
          <div className="ratingReviewContainer">
            <span className="rating">{vendor.rating.toFixed(1) || 0}</span>
            <span className="reviews">({vendor.noOfReviews || vendor.totalReviews || 0})</span>
            <span className="star">★</span>
          </div>
        </div>
        <p>{formatCityRegion(vendor.sellerAddress) || 'N/A'}</p>
        <p className="doubleLineSmallText">{vendor.description || 'No description'}</p>
      </div>
    </div>
  );
};

export default VendorCard;